import asyncActionType from "../../utils/asyncActionType";

export const FETCH_PRICE_LISTS = asyncActionType("FETCH_PRICE_LISTS");
export const FETCH_PRICE_LISTS_DETAIL = asyncActionType("FETCH_PRICE_LISTS_DETAIL");
export const FETCH_PRICES = asyncActionType("FETCH_PRICES");
export const REPROCESS_PRICE = asyncActionType("REPROCESS_PRICE");
export const FETCH_PRICES_LIST_ERRORS = asyncActionType("FETCH_PRICES_LIST_ERRORS");
export const COMPARE_PRICE_LISTS = asyncActionType("COMPARE_PRICE_LISTS");
export const PRICE_LIST_SUBMIT = asyncActionType("PRICE_LIST_SUBMIT");
